import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Mysore() {
  const [openFaq, setOpenFaq] = useState(null);
  const navigate = useNavigate();



  const tripCards = [
    {
      icon: "🏰",
      iconBg: "bg-purple-100 text-purple-600",
      title: "Interesting Facts About Mysore",
      desc: (
        <>
          Mysore, also called <strong>Mysuru</strong>, is known for its rich cultural heritage and royal history. It was the capital of the <strong>Mysore Kingdom</strong> and is famous for landmarks like the <strong>Mysore Palace</strong>, <strong>Chamundi Hill</strong>, and the historic <strong>St. Philomena's Church</strong>. The city is also renowned for its sandalwood and silk industries.
        </>
      ),
    },
    {
      icon: "🎉",
      iconBg: "bg-red-100 text-red-600",
      title: "Famous Festivals in Mysore",
      desc: (
        <>
          Mysore is renowned for its vibrant festivals, especially the <strong>Mysore Dasara</strong>, a 10-day royal celebration featuring processions, cultural performances, and decorated elephants. Other festivals include <strong>Diwali</strong>, <strong>Ugadi</strong>, and <strong>Navaratri</strong>, making it a lively destination for cultural tourism.
        </>
      ),
    },
    {
      icon: "🌤️",
      iconBg: "bg-yellow-100 text-yellow-600",
      title: "Best Time to Visit Mysore",
      desc: (
        <>
          The best time to explore Mysore is from <strong>October to March</strong>, when the weather is cool and pleasant. This period is ideal for sightseeing, enjoying the Dasara festivities, and exploring nearby attractions like <strong>Brindavan Gardens</strong> and <strong>Srirangapatna</strong> comfortably.
        </>
      ),
    },
  ];


  const longTrips = [
    {
      title: "Mysore – Coorg",
      type: "Scenic Route",
      distance: "120 km",
      description:
        "Known as the Scotland of India, ideal for coffee plantations, waterfalls, and hill station vibes.",
      bgGradient: "linear-gradient(to top left, rgb(99, 165, 55), rgb(140, 231, 178))",
      circleColor: "#F97316",
    },
    {
      title: "Mysore – Ooty",
      type: "Hill Drive",
      distance: "125 km",
      description: "A favorite hill station with tea gardens and cool climate.",
      bgGradient: "linear-gradient(to top left, rgb(99, 165, 55), rgb(65, 179, 112))",
      circleColor: "#F59E0B",
    },
    {
      title: "Mysore – Chikmagalur",
      type: "Coffee Trail",
      distance: "250 km",
      description: "Famous for its coffee estates and trekking routes.",
      bgGradient: "linear-gradient(to top left, rgb(99, 165, 55), rgb(65, 179, 112))",
      circleColor: "#D97706",
    },
    {
      title: "Mysore – Bangalore",
      type: "City Drive",
      distance: "150 km",
      description: "A quick drive if you want a city getaway.",
      bgGradient: "linear-gradient(to top left, rgb(99, 165, 55), rgb(65, 179, 112))",
      circleColor: "#2563EB",
    },
    {
      title: "Mysore – Wayanad",
      type: "Nature Trail",
      distance: "140 km",
      description:
        "The Wayanad Wildlife Sanctuary is a lush, forested region with areas of high altitude.",
      bgGradient: "linear-gradient(to top left, rgb(99, 165, 55), rgb(65, 179, 112))",
      circleColor: "#8B5CF6",
    },
  ];

  const faqs = [
    {
      q: "How can I book a self drive car in Mysore with Wow carz?",
      a: "Booking is simple: visit the website or app, choose your car, select a package (hourly/daily/weekly or 100 km trip), and confirm. You'll receive a booking confirmation and pickup details.",
    },
    {
      q: "What documents are required to rent a car in Mysore?",
      a: "You need a valid driving license (minimum age 21 and at least 1 year of driving history) and a government-issued ID (Aadhar or Passport).",
    },
    {
      q: "Can I rent a car for a short trip within the city?",
      a: "Yes — Wow carz offers hourly, daily and weekly packages suitable for city travel, sightseeing, and short outings.",
    },
    {
      q: "Is it possible to take the rental car outside Mysore?",
      a: "Yes — choose the appropriate outstation package to drive to nearby destinations like Coorg, Ooty, Chikmagalur, and Bangalore. Check package details for kilometer limits and charges.",
    },
    {
      q: "Does Wow carz provide airport, railway station, or hotel car delivery in Mysore?",
      a: "Yes — Wow carz offers 24/7 Mysore Airport, Mysore Railway Station, Bus Stand pickup/drop, and doorstep delivery for hassle-free rentals.",
    },
    {
      q: "Are Wow carz rentals available for both short and long durations?",
      a: "Yes — you can book hourly packages for short trips or daily/weekly rentals for long trips and weekend getaways.",
    },
  ];

  const places = [
    {
      image: "/assets/mysorepalace.jpg",
      title: "Mysore Palace",
      desc: "One of the most iconic landmarks in India, the Mysore Palace is a blend of Indo-Saracenic architecture with stunning interiors, royal courtyards, and dazzling illumination at night.",
    },
    {
      image: "/assets/chamundihills.jpg",
      title: "Chamundi Hills",
      desc: "Located just 13 km from the city, Chamundi Hills is famous for the Chamundeshwari Temple and panoramic views of Mysore. Drive with Wow carz for a quick short trip within 100 kms.",
    },
    {
      image: "/assets/brindahavangarderns.jpg",
      title: "Brindavan Gardens",
      desc: "Known for its musical fountain show, Brindavan Gardens is a perfect spot for families and evening relaxation. Located about 21 km from Mysore, it makes a great trip within 100 kms.",
    },
    {
      image: "/assets/stphilomenas.jpg",
      title: "St. Philomena’s Church",
      desc: "A beautiful neo-gothic style cathedral, St. Philomena’s Church is one of the tallest churches in Asia and a must-visit attraction while exploring travel within the city.",
    },
    {
      image: "/assets/mysorezoo.png",
      title: "Mysore Zoo",
      desc: "One of the oldest and most well-maintained zoos in India, Mysore Zoo is home to a wide range of animals and is an ideal place for a short trip with kids and family.",
    },
    {
      image: "/assets/karanjilake.jpg",
      title: "Karanji Lake",
      desc: "A peaceful getaway within the city, Karanji Lake is perfect for boating and bird watching. If you want to rent a car hassle free and enjoy a calm day, this is the spot.",
    },

  ];

  const whyCards = [
    {
      title: "Wide Range of Cars",
      text: "Perfect for city travel, short trips, or long trips up to 350 km. Affordable options with no hidden costs.",
    },
    {
      title: "Hassle-Free Booking",
      text: "Book your ride in minutes, pick up, drive, and enjoy – no stress, no paperwork.",
    },
    {
      title: "24/7 Support & Delivery",
      text: "Airport, railway, bus stand pickup, and doorstep delivery. Travel freely with full support anytime.",
    },
  ];

  // Mobile slider settings
  const mobileSliderSettings = {
    dots: true,
    responsive: [{ breakpoint: 768, settings: { arrows: false } }],
    infinite: false,
    speed: 500,
    slidesToShow: 1.1,
    slidesToScroll: 1,
    swipeToSlide: true,
  };

  return (
    <div className="min-h-screen bg-grey-50 text-gray-800 font-inter">
      {/* Header */}
      <header className="bg-lime-100 shadow-sm sticky top-0 z-20">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <div className="flex-shrink-0">
            <img
              onClick={() => navigate("/")}
              loading="lazy"
              style={{ height: 55, width: 160 }}
              src="https://bagzpack.s3.amazonaws.com/logo/68ea80da-f61b-4333-a4ed-ebae07c63893/IMG/1645694302682.png"
              alt="wowcarzlogo"
              className="object-cover cursor-pointer"
            />
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4">
            <div className="flex items-center gap-3 mt-2 sm:mt-0">
              <a
                href="/"
                className="bg-green-500 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-600 transition"
              >
                Book Now
              </a>
              <a
                href="tel:+919844300066"
                className="inline-flex items-center gap-2 border border-gray-200 px-3 py-2 rounded-lg text-sm hover:bg-gray-100 transition"
              >
                📞 Call Us
              </a>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {/* Hero Section */}
        <section className="relative rounded-2xl h-[500px] sm:h-[550px] lg:h-[600px] overflow-hidden">

          <img
            src="/assets/mys.jpg"
            alt="Self Drive Cars Chennai"
            className="absolute inset-0 w-full h-full object-contain scale-125"
          />

          <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-center px-6 sm:px-12">
            <h2 className="text-3xl sm:text-5xl font-bold text-white mb-4 animate-fade-in">
              Self Drive Cars in Mysore
            </h2>
            <p className="text-gray-200 text-base sm:text-lg mb-6 max-w-xl leading-relaxed">
              Explore Mysore and nearby destinations with hassle-free self drive
              cars from Wow Carz.
            </p>
          </div>
        </section>

        {/* Explore Mysore Section */}
        <section className="bg-lime-100 p-3 m-2">
          <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-3xl p-8 sm:p-12 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-6">
              Explore Mysore with Wow Carz
            </h2>
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
              Mysore, also known as the City of Palaces, is one of the most
              charming travel destinations in Karnataka. Known for its royal
              heritage, magnificent architecture, serene gardens, and cultural
              richness, Mysore attracts tourists from all over the world.
              Whether you’re planning a short trip within 100 kms, a long trip
              of 250 km or even 350 km, <strong>Wow Carz</strong> makes your journey easier with
              self drive car in Mysore options. With our flexible car rental in
              Mysore, you can travel at your own pace – be it exploring the
              city, nearby hill stations, or weekend getaways. We provide 24/7
              Mysore Airport pick up and drop, along with doorstep delivery
              24/7, so you can rent a car hassle free and start your adventure
              without any delays.
            </p>
          </div>
        </section>

        {/* Why Choose Wow Carz */}
        <section className="mt-16">
          <h3 className="text-2xl font-semibold text-gray-900 mb-6 text-center">
            Why Choose Wow Carz in Mysore?
          </h3>

          {/* Desktop grid */}
          <div className="hidden md:grid grid-cols-3 gap-8 max-w-6xl mx-auto">
            {whyCards.map((card, i) => (
              <div
                key={i}
                className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
                <p className="text-gray-600">{card.text}</p>
              </div>
            ))}
          </div>

          {/* Mobile slider */}
          <div className="block md:hidden max-w-xl mx-auto">
            <Slider {...mobileSliderSettings}>
              {whyCards.map((card, i) => (
                <div key={i} className="px-2">
                  <div className="bg-white p-6 rounded-2xl shadow-lg">
                    <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
                    <p className="text-gray-600">{card.text}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </section>

        {/* Plan Your Trip */}
        <section className="py-16 bg-lime-200 m-3 p-3">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-bold mb-12 text-gray-900">
              Plan Your Trip to Mysore
            </h2>

            {/* Mobile Carousel */}
            <div className="md:hidden">
              <Slider {...mobileSliderSettings}>
                {tripCards.map((card, index) => (
                  <div key={index} className="px-2">
                    <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                      <div className={`w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full text-2xl ${card.iconBg}`}>
                        {card.icon}
                      </div>
                      <h3 className="text-xl font-semibold mb-4">{card.title}</h3>
                      <p className="text-gray-700 leading-relaxed text-sm">{card.desc}</p>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>

            {/* Desktop Grid */}
            <div className="hidden md:grid grid-cols-1 md:grid-cols-3 gap-8">
              {tripCards.map((card, index) => (
                <div key={index} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className={`w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full text-2xl ${card.iconBg}`}>
                    {card.icon}
                  </div>
                  <h3 className="text-xl font-semibold mb-4">{card.title}</h3>
                  <p className="text-gray-700 leading-relaxed text-sm">{card.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>


        {/* Top Places */}
        <section className="mt-12">
          <h3 className="text-2xl font-semibold text-gray-900 mb-2 text-center">
            Top Places to Visit in Mysore
          </h3>
          <p className="text-gray-600 mb-6 text-center">
            Explore iconic landmarks, serene gardens, and historic towns with
            your Wow Carz ride.
          </p>

          {/* Desktop grid */}
          <div className="hidden sm:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-4">
            {places.map((place) => (
              <article key={place.title} className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl border border-gray-100 hover:border-blue-300 transition-transform duration-300 transform hover:-translate-y-2 hover:scale-105 text-center">
                <div className="overflow-hidden rounded-xl mb-4">
                  <img
                    className="w-48 h-48 object-cover rounded-xl mx-auto transition-transform duration-300 transform hover:scale-110"
                    src={place?.image}
                    alt={place.title}
                  />
                </div>
                <h4 className="font-semibold text-xl text-gray-800 mb-2">
                  {place.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">{place.desc}</p>
              </article>
            ))}
          </div>

          {/* Mobile slider */}
          <div className="block sm:hidden max-w-xl mx-auto">
            <Slider {...mobileSliderSettings}>
              {places.map((place) => (
                <div key={place.title} className="px-2">
                  <article className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <div className="overflow-hidden rounded-xl mb-4">
                      <img
                        className="w-48 h-48 object-cover rounded-xl mx-auto"
                        src={place?.image}
                        alt={place.title}
                      />
                    </div>
                    <h4 className="font-semibold text-xl text-gray-800 mb-2">{place.title}</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">{place.desc}</p>
                  </article>
                </div>
              ))}
            </Slider>
          </div>
        </section>

        {/* Nearby Long Trips */}
        <section className="mt-16">
          <h3 className="text-2xl font-semibold text-gray-900 mb-2 text-center">
            Nearby Long Trips (250 km – 350 km)
          </h3>
          <p className="text-gray-600 mb-6 text-center">
            Plan exciting weekend getaways with your Wow Carz rental from Mysore.
          </p>

          {/* Desktop grid */}
          <div className="hidden lg:grid grid-cols-5 gap-8 px-4">
            {longTrips.map((trip) => (
              <div
                key={trip.title}
                className="card m-auto text-gray-300 w-[clamp(260px,80%,300px)] hover:brightness-90 transition-all cursor-pointer group rounded-lg overflow-hidden relative border-r-2 border-t-2 border-gray-900 m-4"
                style={{
                  background: trip.bgGradient,
                  minHeight: "300px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div className="px-8 py-10">
                  <div className="uppercase text-white font-bold text-xl">{trip.title}</div>
                  <div className="text-gray-300 text-white uppercase tracking-widest">{trip.type}</div>
                  <div className="text-gray-400 text-white mt-8">
                    <p className="font-bold text-white">{trip.distance}</p>
                    <p>{trip.description}</p>
                  </div>
                </div>
                <div className="h-2 w-full bg-gradient-to-l via-yellow-500 group-hover:blur-xl blur-2xl m-auto rounded transition-all absolute bottom-0"></div>
                <div className="h-0.5 group-hover:w-full bg-gradient-to-l via-yellow-950 group-hover:via-yellow-500 w-[70%] m-auto rounded transition-all"></div>
              </div>
            ))}
          </div>

          {/* Mobile slider */}
          <div className="block lg:hidden max-w-xl mx-auto">
            <Slider {...mobileSliderSettings}>
              {longTrips.map((trip) => (
                <div key={trip.title} className="px-2">
                  <div
                    className="card text-gray-300 w-full hover:brightness-90 transition-all cursor-pointer group rounded-lg overflow-hidden relative border-r-2 border-t-2 border-gray-900 m-4"
                    style={{
                      background: trip.bgGradient,
                      minHeight: "300px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="px-8 py-10">
                      <div className="uppercase text-white font-bold text-xl">{trip.title}</div>
                      <div className="text-gray-300 text-white uppercase tracking-widest">{trip.type}</div>
                      <div className="text-gray-400 text-white mt-8">
                        <p className="font-bold text-white">{trip.distance}</p>
                        <p>{trip.description}</p>
                      </div>
                    </div>
                    <div className="h-2 w-full bg-gradient-to-l via-yellow-500 group-hover:blur-xl blur-2xl m-auto rounded transition-all absolute bottom-0"></div>
                    <div className="h-0.5 group-hover:w-full bg-gradient-to-l via-yellow-950 group-hover:via-yellow-500 w-[70%] m-auto rounded transition-all"></div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="mt-20">
          <h3 className="text-2xl font-semibold text-gray-900 mb-6 text-center">
            Frequently Asked Questions
          </h3>
          <div className="max-w-4xl mx-auto">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="border-b border-gray-200 py-4 cursor-pointer"
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
              >
                <h4 className="text-lg font-medium flex justify-between items-center">
                  {faq.q}{" "}
                  <span className="ml-4">{openFaq === i ? "−" : "+"}</span>
                </h4>
                {openFaq === i && <p className="text-gray-600 mt-2">{faq.a}</p>}
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="mt-16 bg-gradient-to-r from-green-300 via-green-500 to-green-500 text-white p-8 rounded-3xl flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="text-center sm:text-left">
            <h4 className="text-2xl font-semibold">
              Ready to Start Your Journey?
            </h4>
            <p className="text-sm mt-2 text-blue-100">
              Experience hassle-free driving with Wow Carz today.
            </p>
          </div>
          <div className="flex gap-3">
            <a
              href="/"
              className="bg-white text-blue-600 px-6 py-3 rounded-lg font-medium hover:bg-blue-100 transition"
            >
              Book Now
            </a>
            <a
              href="tel:+919844300066"
              className="border border-white px-6 py-3 rounded-lg hover:bg-white hover:text-blue-600 transition"
            >
              Call Us
            </a>
          </div>
        </section>

        {/* Footer */}
        <footer className="mt-10 text-center text-sm text-gray-500">
          © {new Date().getFullYear()} Wow Carz — All rights reserved
        </footer>
      </main>
    </div>
  );
}

export default Mysore;
